import * as React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Pagination as PaginationContainer, PaginationContent, PaginationEllipsis, PaginationItem } from "@/components/ui/pagination";
import { buttonVariants } from "@/components/ui/button";
interface PaginationProps {
  currentPage: number;
  totalPosts: number;
  postsPerPage?: number;
  onPageChange: (page: number) => void;
}
export default function Pagination({
  currentPage,
  totalPosts,
  postsPerPage = 12,
  onPageChange
}: PaginationProps) {
  const totalPages = Math.ceil(totalPosts / postsPerPage);
  if (totalPages <= 1) {
    return null;
  }
  const handlePageClick = (e: React.MouseEvent, page: number) => {
    e.preventDefault();
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      onPageChange(page);
    }
  };
  const getPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  };
  const pages = getPageNumbers();
  return <section id="pagination" className="w-full bg-background py-12 md:py-16">
      <div className="container mx-auto px-4">
        <PaginationContainer>
          <PaginationContent className="gap-1 sm:gap-2">
            <PaginationItem>
              <Link to="#" onClick={e => handlePageClick(e, currentPage - 1)} className={`${buttonVariants({
              variant: "outline"
            })} h-8 gap-1 px-2 text-xs sm:h-10 sm:px-4 sm:text-sm ${currentPage === 1 ? "pointer-events-none opacity-50" : ""}`} aria-label="Go to previous page">
                <ChevronLeft className="size-3 sm:size-4" />
                <span className="hidden sm:inline">Previous</span>
              </Link>
            </PaginationItem>

            {pages.map((pageNum, i) => <PaginationItem key={pageNum} data-index={i}>
                <Link to="#" onClick={e => handlePageClick(e, pageNum)} className={`${buttonVariants({
              variant: pageNum === currentPage ? "default" : "outline"
            })} h-8 w-8 p-0 text-xs sm:h-10 sm:w-10 sm:text-sm`} aria-current={pageNum === currentPage ? "page" : undefined}>
                  {pageNum}
                </Link>
              </PaginationItem>)}

            <PaginationItem>
              <Link to="#" onClick={e => handlePageClick(e, currentPage + 1)} className={`${buttonVariants({
              variant: "outline"
            })} h-8 gap-1 px-2 text-xs sm:h-10 sm:px-4 sm:text-sm ${currentPage === totalPages ? "pointer-events-none opacity-50" : ""}`} aria-label="Go to next page">
                <span className="hidden sm:inline">Next</span>
                <ChevronRight className="size-3 sm:size-4" />
              </Link>
            </PaginationItem>
          </PaginationContent>
        </PaginationContainer>
      </div>
    </section>;
}